import React from 'react';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useLocation, Link } from 'react-router-dom';
import logoSeal from '../../assets/images/logoSeal.png';
import { useState } from 'react';

const TheNavigation = ({ userState, username, slug }) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const WILL_CREATION_URL = process.env.REACT_APP_WILL_CREATION_URL;
  const WILL_REGISTRATION_URL = process.env.REACT_APP_WILL_REGISTRATION_URL;
  const [expanded, setExpanded] = useState<boolean>(false);
  const token = localStorage.getItem('attorney_registration_token');
  const isLoginPath = pathname.toLowerCase().includes('login');

  const handleSelect = () => {
    setExpanded(false); // Collapse the Navbar when a NavItem is clicked
  };

  const handleToggle = () => {
    setExpanded(!expanded); // Toggle the expanded state when the toggle button is clicked
  };
  return (
    <div className="bottom-header">
      <Navbar
        expand="lg"
        expanded={expanded}
        className="navbar-second"
        onToggle={handleToggle}
      >
        <Container
          className={
            userState?.isLoggedIn && !userState?.user.is_profile_complete
              ? 'justify-content-end'
              : ''
          }
        >
          <div className="m-menu-brand menu-list">
            {!!(
              !userState?.isLoggedIn || userState?.user.is_profile_complete
            ) && (
                <div>
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="border-0 toggle-btn"
                  >
                    <i className="fa fa-bars text-white" aria-hidden="true"></i>
                  </Navbar.Toggle>
                  <Navbar.Brand className="menu-box">MENU</Navbar.Brand>
                </div>
              )}
            {token && (
              <Dropdown className="user-menu">
                <Dropdown.Toggle as="div" className="menu-button">
                  <span>{username}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Header>Access Your Account</Dropdown.Header>
                  <div className="menu-items">
                    {!!(
                      userState?.user?.password_changed &&
                      userState?.user?.is_profile_complete &&
                      userState?.user?.subscription !== null
                    ) && (
                        <>
                          <Dropdown.Item as={Link} to="/account-details">
                            Account Details
                          </Dropdown.Item>
                          <Dropdown.Item
                            as={Link}
                            to={`/attorney-directory/${slug}`}
                            state={{
                              from: '/account-details',
                            }}
                          >
                            View Profile
                          </Dropdown.Item>
                          <Dropdown.Item as={Link} to="/profile">
                            Edit Profile
                          </Dropdown.Item>
                        </>
                      )}
                    <Dropdown.Item as={Link} to="/logout">
                      Logout
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {!token && !isLoginPath && (
              <Nav.Item className="d-flex align-items-center user-menu">
                <Nav.Link
                  as={Link}
                  to="/login"
                  eventKey="1"
                  className="fow-button fow-button-orange login-btn btn px-3 py-1"
                >
                  Login
                </Nav.Link>
              </Nav.Item>
            )}
          </div>
          <div className="desktop-logoSeal">
            <img
              className="img-fluids"
              src={logoSeal}
              alt="Desktop Seal Logo"
            />
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            {!!(
              !userState?.isLoggedIn || userState?.user.is_profile_complete
            ) && (
                <Nav className="nav-main">
                  <Nav.Item className="header-link" onClick={handleSelect}>
                    <Nav.Link
                      as={Link}
                      to={`${WILL_CREATION_URL}`}
                      className={`nav-link text-white`}
                    >
                      Home
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="header-link" onClick={handleSelect}>
                    <Nav.Link
                      as={Link}
                      to={`/find-an-attorney`}
                      className={`nav-link text-white ${location?.pathname.includes('find-an-attorney')
                          ? 'active'
                          : ''
                        }`}
                    >
                      Find an Attorney
                    </Nav.Link>
                  </Nav.Item>
                  {!userState?.user.is_profile_complete && (
                    <Nav.Item className="header-link" onClick={handleSelect}>
                      <Nav.Link
                        as={Link}
                        to={`/attorney-registration`}
                        className={`nav-link text-white ${location?.pathname.includes('attorney-registration')
                            ? 'active'
                            : ''
                          }`}
                      >
                        Attorney Registration
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  <Nav.Item className="header-link">
                    <Nav.Link
                      as={Link}
                      to={`${WILL_REGISTRATION_URL}/register-your-will`}
                      className={`nav-link text-white ${location?.pathname.includes('register-your-will')
                          ? 'active'
                          : ''
                        }`}
                    >
                      Register Your Will
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="header-link">
                    <Nav.Link
                      as={Link}
                      to={`${WILL_REGISTRATION_URL}/find-a-missing-will`}
                      className={`nav-link text-white ${location?.pathname.includes('find-a-missing-will')
                          ? 'active'
                          : ''
                        }`}
                    >
                      Find a Will
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="header-link" onClick={handleSelect}>
                    <Nav.Link
                      as={Link}
                      to={`${WILL_CREATION_URL}/obituaries-and-death-notices`}
                      className={`nav-link text-white ${location?.pathname.includes('obituaries-and-death-notices')
                          ? 'active'
                          : ''
                        }`}
                    >
                      Obituary/Death Notices
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default TheNavigation;
